import { render, staticRenderFns } from "./projectCostBudgetSheet.vue?vue&type=template&id=0fa7c25c&scoped=true"
import script from "./projectCostBudgetSheet.vue?vue&type=script&lang=ts"
export * from "./projectCostBudgetSheet.vue?vue&type=script&lang=ts"
import style0 from "./projectCostBudgetSheet.vue?vue&type=style&index=0&id=0fa7c25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7c25c",
  null
  
)

export default component.exports